import React, { useEffect } from 'react'
import styles from '../style';
import { TechnologyHeader, TechnologyListing, Footer } from '../components';

const Technology = () => {

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className={`bg-primary ${styles.flexStart}`}>
        <div className={`${styles.boxWidth}`}>
          <TechnologyHeader />
        </div>
      </div>

      <div>
        <TechnologyListing/>
      </div>

      <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
        <div className={`${styles.boxWidth}`}>
          <Footer />
        </div>
      </div>
     
    </div>
  )
}

export default Technology;